module.exports = function() {
  return new Worker(__webpack_public_path__ + "42c1d7839ad4873d387e.worker.js");
};